<template>
  <div class="dsfa-sc-todo-center">
    <DsfSCPanel
      :title="title"
      :more="acItem.moreConfig && acItem.moreConfig.show"
      :moreConfig="acItem.moreConfig"
    >
      <template #header>
        <div class="dsfa-sc-todo-center-header__ft-tabs">
          <div
            :class="[
              'dsfa-sc-todo-center-header__ft-tab',
              current === index ? 'active' : '',
            ]"
            v-for="(item, index) in tabs"
            :key="index"
            @click="current = index"
          >
            {{ item }}
          </div>
        </div>
      </template>
      <div class="dsfa-sc-todo-center-content">
        <dsf-virtual-scroll scroll-Y>
          <DsfSCTodoWorkList :dataList="acItem.dataList"></DsfSCTodoWorkList>
        </dsf-virtual-scroll>
      </div>
    </DsfSCPanel>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfSCTodoCenter",
  ctrlCaption: "待办中心",
  mixins: [$mixins.control],
  components: {},
  data() {
    return {
      title: "",
      current: 0,
      tabs: [],
      tabsList: {},
    };
  },
  computed: {
    acItem() {
      return this.tabsList[this.tabs[this.current]] || {};
    },
  },
  created() {
    this.$http.get("/static/data/dsf.sctodocenter.json").then(({ data }) => {
      this.tabs = data.tabs;
      this.tabsList = data.tabsList;
      this.title = data.title || "待办中心";
    });
  },
  methods: {},
});
</script>

<style lang="scss">
@import '_statistics-cloud/assets/styles/pc/todoCenter.scss';
@import '_statistics-cloud/assets/styles/pc/todoWork.scss';
</style>